import { useNavigate } from "react-router-dom";

function DashboardSidebar({useSectionNameFn}) {
    const navigate = useNavigate();

     const section = useSectionNameFn;
    return (
        <div class="flex-shrink-0 p-3 col-1" style={{ width: "280px" }}>
            <a href="#" class="d-flex align-items-center mb-3 link-body-emphasis text-decoration-none border-bottom" style={{paddingBottom:"1.6rem"}}>
                <span class="fs-5 fw-semibold">Dashboard</span>
            </a>
            <ul class="list-unstyled ps-0">
                <li class="mb-1">
                    <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0" data-bs-toggle="collapse" data-bs-target="#home-collapse" aria-expanded="true">
                        Monitoring
                    </button>
                    <div class="collapse show" id="home-collapse" >
                        <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                            <li><a href="#active-subscription" class="link-body-emphasis d-inline-flex text-decoration-none rounded" onClick={(e) => {e.preventDefault();  section("Active Subscriptions"); navigate("/Dashboard") }}>Active Subscriptions</a></li>
                            {/* <li><a href="#subscription-usage" class="link-body-emphasis d-inline-flex text-decoration-none rounded" onClick={(e) => { e.preventDefault();  navigate("/Usage") }}>Usage</a></li> */}
                            {/* <li><a href="#account-billing" class="link-body-emphasis d-inline-flex text-decoration-none rounded" onClick={(e) => {e.preventDefault(); section("Billing");}}>Billing</a></li> */}
                        </ul>
                    </div>
                </li>
                <li class="border-top my-3"></li>
                {/* <li class="mb-1">
                    <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed" data-bs-toggle="collapse" data-bs-target="#account-collapse" aria-expanded="false">
                        Control Panel
                    </button>
                    <div class="collapse show" id="account-collapse" >
                        <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                            <li><a href="#subscription-alerts" class="link-body-emphasis d-inline-flex text-decoration-none rounded" onClick={(e) => {e.preventDefault(); section("Alerts"); navigate("/Alerts") }}>
                                Alerts
                            </a>
                            </li>
                            <li>
                                <a href="#subscription-matrix" class="link-body-emphasis d-inline-flex text-decoration-none rounded" onClick={(e) => {e.preventDefault(); section("Matrix"); navigate("/Matrix") }}>
                                    Matrix
                                </a>
                            </li>
                        </ul>
                    </div>
                </li> */}
            </ul>
        </div>
    )
}

export default DashboardSidebar;